import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import StarterKitSection from "@/components/landing/StarterKitSection";
import ExplorerSection from "@/components/landing/ExplorerSection";
import ProductsGrid from "@/components/landing/ProductsGrid";
import Testimonials from "@/components/landing/Testimonials";
import LatestPostsSection from "@/components/landing/LatestPostsSection";
import ImmuneShieldSection from "@/components/landing/ImmuneShieldSection";
import FAQ from "@/components/landing/FAQ";
import Footer from "@/components/landing/Footer";
import WhatsAppButton from "@/components/landing/WhatsAppButton";

export default function Landing({ t, language, setLanguage }) {
  return (
    <main className="relative" data-testid="landing-page">
      <Header t={t} language={language} setLanguage={setLanguage} />
      <Hero t={t} />
      <StarterKitSection t={t} />
      <ExplorerSection t={t} language={language} />
      <ProductsGrid t={t} language={language} />
      <Testimonials t={t} />
      <LatestPostsSection />
      <ImmuneShieldSection language={language} />
      <FAQ t={t} />
      <Footer t={t} />
      <WhatsAppButton label={t.whatsapp} />
    </main>
  );
}
